import { toast } from "react-toastify";


class MessagingService {
    constructor() {
        this.baseUrl = process.env.REACT_APP_MESSAGING_API_URL;
        this.clientUserId = null; // Frontend user ID (opcionális)
    }

    setClientUserId(userId) {
        this.clientUserId = userId;
    }

    getAuthHeaders() {
        const headers = {};
        const token = localStorage.getItem('authToken');
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
        return headers;
    }



    // Felhasználók lekérése - client és backend user-ek
    async getUsers() {
        try {


            const headers = this.getAuthHeaders();

            const clientResponse = await fetch(`${this.baseUrl}/get-client-users`, { headers });

            let clientUsers = [];



            if (clientResponse.ok) {
                const clientResult = await clientResponse.json();


                if (clientResult.success) {
                    clientUsers = clientResult.data.map(user => ({
                        id: user.id,
                        name: user.name,
                        email: user.email,
                        company_name: user.company_name || user.client_id || 'Unknown Company',
                        user_type: 'client',
                        status: 'active'
                    }));



                } else {

                    // Teszt adatok ha a backend API nem működik
                    clientUsers = [
                        {
                            id: 'client1',
                            name: 'Teszt Client 1',
                            email: 'client1@example.com',
                            company_name: 'Teszt Cég',
                            user_type: 'client',
                            status: 'active'
                        },
                        {
                            id: 'client2',
                            name: 'Teszt Client 2',
                            email: 'client2@example.com',
                            company_name: 'Teszt Cég',
                            user_type: 'client',
                            status: 'active'
                        }
                    ];
                }
            } else {
                toast.error(' Client response error');
                
            }

            // Backend user-ek lekérése

            const backendResponse = await fetch(`${this.baseUrl}/get-backend-users`, {
                headers
            });

            let backendUsers = [];



            if (backendResponse.ok) {
                const backendResult = await backendResponse.json();


                if (backendResult.success) {
                    backendUsers = backendResult.data.map(user => ({
                        id: user.id,
                        name: user.name,
                        email: user.email,
                        user_type: 'backend',
                        status: 'active'
                    }));


                }
            } else {

            }

            const result = {
                backend_users: backendUsers,
                client_users: clientUsers
            };



            return result;
        } catch (error) {
            console.error('❌ getUsers() error:', error);
            return {
                backend_users: [],
                client_users: []
            };
        }
    }

    // Egyszerű üzenetek lekérése
    async getMessages(folder, page = 1, search = '') {
        try {
            const params = new URLSearchParams({
                folder: folder,
                page: page.toString(),
                limit: '20',
                company_id: '1'
            });

            if (search) {
                params.append('search', search);
            }

            const headers = this.getAuthHeaders();

            const response = await fetch(`${this.baseUrl}/get-messages?${params}`, { headers });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            if (result.success) {
                return {
                    messages: result.data.messages || [],
                    pagination: result.data.pagination || {
                        page: page,
                        per_page: 20,
                        total: 0,
                        total_pages: 1
                    }
                };
            } else {
                throw new Error(result.message || 'Hiba az üzenetek lekérésekor');
            }
        } catch (error) {
            // Fallback üres listára
            return {
                messages: [],
                pagination: {
                    page: page,
                    per_page: 20,
                    total: 0,
                    total_pages: 1
                }
            };
        }
    }

    // Piszkozat mentése
    async saveDraft(messageData) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...this.getAuthHeaders()
            };

            const requestData = {
                subject: messageData.subject,
                content: messageData.content,
                priority: messageData.priority || 'normal',
                company_id: 1
            };

            if (messageData.recipients && messageData.recipients.length > 0) {
                requestData.to = messageData.recipients.map(r => {
                    if (r.user_type === 'backend') {
                        return {
                            user_type: r.user_type,
                            user_id: r.user_id
                        };
                    } else if (r.user_type === 'client') {
                        return {
                            user_type: r.user_type,
                            client_id: r.client_id || r.client_user_id
                        };
                    }
                    return r;
                });
            }

            const response = await fetch(`${this.baseUrl}/save-draft`, {
                method: 'POST',
                headers,
                body: JSON.stringify(requestData)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            if (result.success) {
                return result;
            } else {
                throw new Error(result.message || 'Hiba a piszkozat mentésekor');
            }
        } catch (error) {
            
            throw error;
        }
    }

    // Piszkozat frissítése
    async updateDraft(draftId, messageData) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...this.getAuthHeaders()
            };

            const requestData = {
                subject: messageData.subject,
                content: messageData.content,
                priority: messageData.priority || 'normal',
                company_id: 1
            };

            if (messageData.recipients && messageData.recipients.length > 0) {
                requestData.to = messageData.recipients.map(r => {
                    if (r.user_type === 'backend') {
                        return {
                            user_type: r.user_type,
                            user_id: r.user_id
                        };
                    } else if (r.user_type === 'client') {
                        return {
                            user_type: r.user_type,
                            client_id: r.client_id || r.client_user_id
                        };
                    }
                    return r;
                });
            }

            const response = await fetch(`${this.baseUrl}/update-draft/${draftId}`, {
                method: 'PUT',
                headers,
                body: JSON.stringify(requestData)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            if (result.success) {
                return result;
            } else {
                throw new Error(result.message || 'Hiba a piszkozat frissítésekor');
            }
        } catch (error) {
            
            throw error;
        }
    }

    // Egyszerű üzenet küldés
    async sendMessage(messageData) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...this.getAuthHeaders()
            };

            const requestData = {
                to: messageData.recipients.map(r => {
                    if (r.user_type === 'backend') {
                        return {
                            user_type: r.user_type,
                            user_id: r.user_id
                        };
                    } else if (r.user_type === 'client') {
                        return {
                            user_type: r.user_type,
                            client_id: r.client_id || r.client_user_id
                        };
                    }
                    return r;
                }),
                subject: messageData.subject,
                content: messageData.content,
                priority: messageData.priority || 'normal',
                company_id: 1
            };


            
            const response = await fetch(`${this.baseUrl}/send-message`, {
                method: 'POST',
                headers,
                body: JSON.stringify(requestData)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            if (result.success) {
                return result;
            } else {
                throw new Error(result.message || 'Hiba az üzenet küldésekor');
            }
        } catch (error) {
            
            throw error;
        }
    }

    // Egyszerű üzenet törlés - használjuk a bulkActions endpoint-ot
    async deleteMessage(id) {
        try {
            // A deleteMessage most a move_to_trash műveletet használja, hogy az üzenetek a kuka mappába kerüljenek
            return await this.bulkActions('move_to_trash', [id]);
        } catch (error) {
            
            throw error;
        }
    }

    // Egyszerű olvasottként jelölés
    async markAsRead(id) {
        try {
            const response = await fetch(`${this.baseUrl}/mark-read/${id}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    ...this.getAuthHeaders()
                }
            });

            if (!response.ok) {
                // Try to parse error response
                try {
                    const errorText = await response.text();
                    
                    throw new Error(`HTTP error! status: ${response.status} - ${errorText.substring(0, 100)}`);
                } catch (parseError) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
            }

            const result = await response.json();
            if (result.success) {
                return result;
            } else {
                throw new Error(result.message || 'Hiba az üzenet olvasottként jelölésekor');
            }
        } catch (error) {
            
            throw error;
        }
    }

    // Bulk műveletek (tömeges törlés, olvasottként jelölés, kuka mappába helyezés)
    async bulkActions(action, messageIds) {
        try {
            const endpoint = '/message-actions';
            const method = 'POST';

            let backendAction;
            let targetFolder = null;

            switch (action) {
                case 'delete':
                    backendAction = 'delete';
                    break;
                case 'markAsRead':
                    backendAction = 'mark_read';
                    break;
                case 'move_to_trash':
                    backendAction = 'delete';
                    break;
                default:
                    throw new Error(`Ismeretlen bulk művelet: ${action}`);
            }

            const requestBody = {
                action: backendAction,
                message_ids: messageIds
            };

            if (targetFolder) {
                requestBody.target_folder = targetFolder;
            }


            const response = await fetch(`${this.baseUrl}${endpoint}`, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    ...this.getAuthHeaders()
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            if (result.success) {
                return result;
            } else {
                throw new Error(result.message || `Hiba a ${action} művelet végrehajtásakor`);
            }
        } catch (error) {
            toast.error(`Hiba a többszörös művelet végrehajtásakor:`, error);
            throw error;
        }
    }

    // Egyszerű mappa statisztikák
    async getFolderStats() {
        try {
            const headers = this.getAuthHeaders();

            const response = await fetch(`${this.baseUrl}/folder-stats`, { headers });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            if (result.success) {
                return result.data;
            } else {
                throw new Error(result.message || 'Hiba a mappa statisztikák lekérésekor');
            }
        } catch (error) {
            // Don't show toast for auth errors — global handler will redirect to login
            if (!String(error.message).includes('401')) {
                toast.error('Hiba a mappa statisztikák lekérésekor:', error);
            }
            // Fallback üres statisztikákra
            return {
                inbox: { total: 0, unread: 0 },
                sent: { total: 0, unread: 0 },
                drafts: { total: 0, unread: 0 },
                favorites: { total: 0, unread: 0 },
                system: { total: 0, unread: 0 },
                trash: { total: 0, unread: 0 }
            };
        }
    }

    // Csatolmány feltöltése
    async uploadAttachment(file, messageId) {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('message_id', messageId);

            const response = await fetch(`${this.baseUrl}/upload-attachment`, {
                method: 'POST',
                headers: this.getAuthHeaders(),
                body: formData
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            if (result.success) {
                return result.data;
            } else {
                throw new Error(result.message || 'Hiba a csatolmány feltöltésekor');
            }
        } catch (error) {
            toast.error('Hiba a csatolmány feltöltésekor:', error);
            throw error;
        }
    }

    // Csatolmányok lekérése egy üzenethez
    async getMessageAttachments(messageId) {
        try {
            
            const folders = ['inbox', 'sent', 'drafts'];
            for (const folder of folders) {
                try {
                    const response = await fetch(`${this.baseUrl}/get-messages?folder=${folder}&page=1&limit=100`, {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            ...this.getAuthHeaders()
                        }
                    });

                    if (response.ok) {
                        const result = await response.json();
                        
                        
                        if (result.success && result.data && result.data.messages) {
                            // Find the specific message by ID
                            const message = result.data.messages.find(msg => msg.id == messageId);
                            if (message) {
                               
                                if (message.attachments && Array.isArray(message.attachments)) {
                                    
                                    return message.attachments;
                                }
                            }
                        }
                    }
                } catch (error) {
                    toast.warn(`MessagingService: Hiba a csatolmányok lekérésekor:`);
                }
            }
            
           
            return [];
        } catch (error) {
            
            return [];
        }
    }

    // Üzenet kedvencekhez adása/eltávolítása
    async toggleFavorite(messageId) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...this.getAuthHeaders()
            };

            const response = await fetch(`${this.baseUrl}/toggle-favorite/${messageId}`, {
                method: 'POST',
                headers
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            if (result.success) {
                return result;
            } else {
                throw new Error(result.message || 'Hiba a kedvencek művelet során');
            }
        } catch (error) {
            toast.error('Hiba a kedvencek művelet során:', error);
            throw error;
        }
    }

    // Üzenet továbbítása
    async forwardMessage(originalMessageId, forwardData) {
        try {
        
            const response = await fetch(`${this.baseUrl}/forward-message`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...this.getAuthHeaders()
                },
                body: JSON.stringify({
                    original_message_id: originalMessageId,
                    recipients: forwardData.recipients,
                    subject: forwardData.subject,
                    content: forwardData.content,
                    priority: forwardData.priority || 'normal',
                    copy_attachments: forwardData.copyAttachments || false
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
           
            return result;
        } catch (error) {
            toast.error(' Hiba a továbbítás során:');
            throw error;
        }
    }
}

export default MessagingService;
